import * as profile from "./profile"
import * as submission from "./submission"

export const implementer = { profile, submission }
